import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon, ExternalLinkIcon } from 'lucide-react';
import { TESTIMONIALS } from '../data/testimonials';
export function TestimonialsSection() {
  return <section className="relative bg-night-2 px-6 sm:px-8 lg:px-12 py-20 md:py-28 overflow-hidden" data-id="element-484" data-mp="1n0twv1n49nc8">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(61,107,61,.07) 0%, transparent 70%)'
    }} data-id="element-485" data-mp="1r0ubama7tyja" />
      <div className="relative max-w-6xl mx-auto" data-id="element-486" data-mp="1hyux01ql58k1">
        <motion.div initial={{
        opacity: 0,
        y: 35
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-487" data-mp="1427xbr7904af">
          <span className="inline-block text-[0.67rem] font-semibold tracking-[0.3em] uppercase text-gold mb-5" data-id="element-488" data-mp="2ydcxumn1g0lj">
            Testimonios
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.15] text-white mb-8" data-id="element-489" data-mp="2v0j67psq04zs">
            Lo que dicen
            <br data-id="element-490" data-mp="2q0nasey39lvu" />
            <em className="italic text-gold" data-id="element-491" data-mp="34r4bfw2wg7ro">quienes ya vivieron esto</em>
          </h2>
          
          <a href="https://www.google.com/maps/search/Refugio+Caracoli+Glamping+Payande+Tolima" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-3 bg-white/5 hover:bg-white/10 border border-white/10 hover:border-gold/30 transition-all px-6 py-3 rounded-full group" data-id="element-492" data-mp="2zsknxr8nqnx7">
            <div className="flex gap-0.5" data-id="element-493" data-mp="2m27fzovrn97v">
              {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="w-4 h-4 text-[#fbbc04] fill-[#fbbc04]" data-id="element-494" data-mp="2h0i3e4swanho" data-mpi={s} />)}
            </div>
            <div className="flex items-center gap-2 text-sm text-white/80" data-id="element-495" data-mp="1ci3vjmg61iv">
              <span className="font-semibold text-white" data-id="element-496" data-mp="3sgowqlmizh44">4.9</span>
              <span data-id="element-497" data-mp="3dqvmt2vmko9">en Google Maps</span>
              <span className="text-white/40" data-id="element-498" data-mp="3gv5a5z428mb">(91 reseñas)</span>
              <ExternalLinkIcon className="w-3.5 h-3.5 text-white/40 group-hover:text-gold transition-colors ml-1" data-id="element-499" data-mp="8ck9wnpzmfph" />
            </div>
          </a>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7" data-id="element-500" data-mp="ickwqjn2fdyf">
          {TESTIMONIALS.map((t, i) => <motion.div key={t.id} initial={{
          opacity: 0,
          y: 35
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.8,
          delay: i * 0.1
        }} className="bg-white/[0.04] border border-white/[0.07] rounded-3xl p-9 transition-all duration-500 hover:bg-white/[0.07] hover:border-gold/[0.22] hover:-translate-y-1.5" data-id="element-501" data-mp="3guq6tbafhthh" data-mpi={i}>
              <div className="flex gap-1 mb-5" data-id="element-502" data-mp="332a8uowdwlnf">
                {Array.from({
              length: 5
            }).map((_, s) => <StarIcon key={s} className="w-[15px] h-[15px] text-gold fill-gold" data-id="element-503" data-mp="1k6vz71x0q6n7" data-mpi={s} />)}
              </div>
              <p className="font-display text-[1.08rem] font-light italic text-white/95 leading-[1.85] mb-7" data-id="element-504" data-mp="1g6lvxx0m1uc1">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3.5" data-id="element-505" data-mp="1b8ailcb3x1p2">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-forest-500 to-gold flex items-center justify-center font-display text-base text-white shrink-0" data-id="element-506" data-mp="166lbg7r09869">
                  {t.authorInitial}
                </div>
                <div data-id="element-507" data-mp="wfqm2uigpsgl">
                  <span className="block text-sm font-medium text-white" data-id="element-508" data-mp="sfq5p4bsz76w">{t.authorName}</span>
                  <span className="text-[0.7rem] text-white/60" data-id="element-509" data-mp="nh56974dkrji">{t.authorLocation}</span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}